import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
export const renderDropdown = (
  label,
  dropdownlist,
  defaultValue,
  part,
  key,
  renderoptions,
  handleSelectChange,
  marginTop = 40,
  disabled = false
) => {
  return (
    <Autocomplete
      style={{ marginTop: marginTop, width: 400, backgroundColor: "white" }}
      disabled={disabled}
      id="companydropdown"
      options={dropdownlist}
      value={defaultValue ? defaultValue : null}
      getOptionLabel={option => {
        if (!option) return null;
        if (renderoptions[1]) {
          return option[renderoptions[0]] + " - " + option[renderoptions[1]];
        }
        return option[renderoptions[0]];
      }}
      // what is displayed:
      renderOption={(props, option, index) => {
        const attrkey = props.id;
        return (
          <li {...props} key={attrkey}>
            {option[renderoptions[0]]}
            {renderoptions[1] && " - "}
            {renderoptions[1] && option[renderoptions[1]]}
          </li>
        );
      }}
      renderInput={params => (
        <TextField {...params} label={"" + label} variant="outlined" />
      )}
      onChange={(event, value) => {
        console.log("change autocomplete", value, part);

        handleSelectChange(value ? value[key] : "", part);
      }}
    />
  );
};
